module.exports = __webpack_public_path__ + "e4695cdd675d71847f88040720608610.png";